import { viewsetDuck } from '@/shared/ducks/viewsetDuck';

export const DEFAULT_STATE = {};

export const duck = viewsetDuck('bulkAddressGroupsStatuses', '/mgmt/api/bulk-address-groups-status/');

export const { actionTypes, actions, reducer, useAPI } = duck;

export default duck;
